<template>
  <section class="section">
		<div class="container" v-if="tournament.image">
			<img :src="tournament.image" style="margin-bottom: 1rem;" class="main-image">
		</div>
		<p class="subtitle" style="font-size: 1.25rem !important;">{{ startDateFormatted }}</p>
		<p class="title">{{ tournament.name }}</p>
		<gender-group-tags :tags="tournament.genderGroups" :options="{showMissing: true, tagSize: 'is-medium'}"/>
		<num-players-tags :tags="tournament.numberOfPlayers" :options="{showMissing: true, tagSize: 'is-medium'}"/>
		<division-tags :tags="tournament.divisions" :options="{showMissing: true, tagSize: 'is-medium'}"/>
		<div class="container">
			<div class="content is-medium" style="margin-bottom: 1rem;" v-html="tournament.info"/>
		</div>
		<p class="content is-medium has-tournament-address">
			<span style="text-decoration: underline;">Tournament Location</span><br>
			<span style="white-space: pre-line;">{{ tournament.location }}</span>
		</p>
		<p style="margin-bottom: 0.5rem;" class="is-size-5"><span class="has-text-weight-semibold">Price: </span>${{ tournament.price }} per {{ signupAs.toLowerCase() }}</p>
    <registrations-list v-if="!tournament.externalLink" :tournament="tournament" style="margin-bottom: 0.75rem;" class="is-size-5"/>
		<div class="detail-buttons">
			<router-link v-if="!tournament.externalLink" :to="`/tournaments/${tournament.id}/signup`" class="button is-medium is-success is-outlined is-rounded signup-button">Signup ({{ signupAs }})</router-link>
      <a v-if="tournament.externalLink" :href="tournament.externalLink" class="button is-medium is-external is-outlined is-rounded">Signup (External)</a>
		</div>
  </section>
</template>

<script>
	import GenderGroupTags from '@/components/GenderGroupTags.vue';
	import DivisionTags from '@/components/DivisionTags.vue';
	import NumPlayersTags from '@/components/NumPlayersTags.vue';
	import RegistrationsList from '@/components/RegistrationsList.vue';

	import moment from 'moment'

	import tournamentDetails from '@/mixins/tournamentDetails.js'
	import tournamentRetriever from '@/mixins/tournamentRetriever.js'

	export default {
		name: "TournamentDetail",
		mixins: [tournamentRetriever, tournamentDetails],
		components: {
    	GenderGroupTags,
			DivisionTags,
			NumPlayersTags,
			RegistrationsList
		},
		computed: {
			locationLines() {
				return this.tournament.location.split(/\r?\n/).filter(l => !!l);
			}
		}
	}
</script>

<style lang="scss" scoped>
.main-image {
	height: auto;
	max-width: 100%;
}
</style>